export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    try {
      const existingRegistration = await navigator.serviceWorker.getRegistration();

      if (existingRegistration) {
        // console.info('⚡ Service Worker כבר רשום:');
        return existingRegistration;
      }

      const registration = await navigator.serviceWorker.register('/service-worker.js');
      // console.info('✅ Service Worker נרשם בהצלחה:');

      return registration;
    } catch (error) {
      // console.error('❌ שגיאה ברישום Service Worker:', error);
    }
  }
};